import { TooltipConstants } from '@Components/Tooltip';

export const ALIGN_CLASS_NAMES = {
  top: 'align-top',
  right: 'align-right',
  bottom: 'align-bottom',
  left: 'align-left',
};

// Override position of rows headers tooltips
export const placeRightAlignBottom = ({ left, top }, currentEvent, currentTarget, node, place, desiredPlace) => {
  const viewHeight = window.innerHeight;
  const { height: tooltipHeight } = node.getBoundingClientRect();

  // In case when react tooltip changed place from desired - change position and place back to desired
  if (place !== desiredPlace) {
    node.classList.remove(TooltipConstants.placeClassNames[place]);
    node.classList.add(TooltipConstants.placeClassNames[desiredPlace]);
    const { top: targetTop, right: targetRight } = currentTarget.getBoundingClientRect();

    // eslint-disable-next-line no-param-reassign
    top = targetTop - tooltipHeight / 2;
    // eslint-disable-next-line no-param-reassign
    left = targetRight;
  }

  // In case it can not fit the screen height when bottom aligned - make it top aligned
  if (top + tooltipHeight * 1.5 > viewHeight) {
    node.classList.remove(ALIGN_CLASS_NAMES.bottom);
    node.classList.add(ALIGN_CLASS_NAMES.top);
    return {
      top: top - tooltipHeight / 2,
      left,
    };
  }

  // Otherwise - bottom aligned
  node.classList.remove(ALIGN_CLASS_NAMES.top);
  node.classList.add(ALIGN_CLASS_NAMES.bottom);
  return {
    top: top + tooltipHeight / 2,
    left,
  };
};

// Override position of columns headers tooltips
export const placeBottomAlignRight = ({ left, top }, currentEvent, currentTarget, node, place, desiredPlace) => {
  const viewWidth = window.innerWidth;
  const { width: tooltipWidth } = node.getBoundingClientRect();

  // In case when react tooltip changed place from desired - change position and place back to desired
  if (place !== desiredPlace) {
    node.classList.remove(TooltipConstants.placeClassNames[place]);
    node.classList.add(TooltipConstants.placeClassNames[desiredPlace]);
    const { bottom: targetBottom, left: targetLeft } = currentTarget.getBoundingClientRect();

    // eslint-disable-next-line no-param-reassign
    top = targetBottom;
    // eslint-disable-next-line no-param-reassign
    left = targetLeft - tooltipWidth / 2;
  }

  // In case it can not fit the screen width when right aligned - make it left aligned
  if (left + tooltipWidth * 1.5 > viewWidth) {
    node.classList.remove(ALIGN_CLASS_NAMES.right);
    node.classList.add(ALIGN_CLASS_NAMES.left);
    return {
      top,
      left: left - tooltipWidth / 2,
    };
  }

  // Otherwise - right aligned
  node.classList.remove(ALIGN_CLASS_NAMES.left);
  node.classList.add(ALIGN_CLASS_NAMES.right);
  return {
    top,
    left: left + tooltipWidth / 2,
  };
};
